const translations = {
  'Back to home': {
    en: 'Back to home',
    es: 'Volver al inicio',
    pt: 'Voltar ao início'
  },
  'Log in': {
    en: 'Log in',
    es: 'Iniciar sesión',
    pt: 'Fazer login',
  },
  'Create account': {
    en: 'Create account',
    es: 'Crear cuenta',
    pt: 'Criar conta',
  },
  'Register': {
    en: 'Register',
    es: 'Regístrate',
    pt: 'Registre-se',
  },
  'Email': {
    en: 'Email',
    es: 'Correo electrónico',
    pt: 'E-mail',
  },
  'Confirm email': {
    en: 'Confirm email',
    es: 'Confirmar correo electrónico',
    pt: 'Confirme o e-mail',
  },
  'Change Password': {
    en: 'Change Password',
    es: 'Cambiar Contraseña',
    pt: 'Alterar senha',
  },
  'Password': {
    en: 'Password',
    es: 'Contraseña',
    pt: 'Senha',
  },
  'Recover password': {
    en: 'Recover password',
    es: 'Recuperar contraseña',
    pt: 'Recuperar senha',
  },
  'Enter your new password': {
    en: 'Enter your new password',
    es: 'Introduce tu nueva contraseña',
    pt: 'Digite sua nova senha',
  },
  'New password': {
    en: 'New password',
    es: 'Nueva contraseña',
    pt: 'Nova senha',
  },
  'Repeat new password': {
    en: 'Repeat new password',
    es: 'Repite nueva contraseña',
    pt: 'Repita nova senha',
  },
  'Name': {
    en: 'Name',
    es: 'Nombre',
    pt: 'Nome',
  },
  'Last name': {
    en: 'Last name',
    es: 'Apellido',
    pt: 'Sobrenome',
  },
  'This field is required': {
    en: 'This field is required',
    es: 'Este campo es obligatorio',
    pt: 'Este campo é obrigatório'
  },
  'Name is required': {
    en: 'Name is required',
    es: 'Nombre es requerido',
    pt: 'Nome é obrigatório',
  },
  'Last name is required': {
    en: 'Last name is required',
    es: 'Apellido es requerido',
    pt: 'Sobrenome é obrigatório',
  },
  'Email is required': {
    en: 'Email is required',
    es: 'Correo electrónico requerido',
    pt: 'E-mail é obrigatório',
  },
  'Invalid email': {
    en: 'Invalid email',
    es: 'Correo electrónico inválido',
    pt: 'E-mail é inválido',
  },
  'Your emails do no match': {
    en: 'Your emails do no match',
    es: 'Sus correos electrónicos no coinciden',
    pt: 'Seus e-mails não coincidem',
  },
  'Password is required': {
    en: 'Password is required',
    es: 'Contraseña requerida',
    pt: 'Senha é obrigatória',
  },
  'Password must be at least {minLength} characters long': {
    en: 'Password must be at least {minLength} characters long',
    es: 'Contraseña debe tener al menos {minLength} caracteres',
    pt: 'Senha deve ter pelo menos {minLength} caracteres',
  },
  'Must be at most {maxLength} characters long': {
    en: 'Must be at most {maxLength} characters long',
    es: 'Debe tener como máximo {maxLength} caracteres',
    pt: 'Deve ter no máximo {maxLength} caracteres'
  },
  'Login or register with': {
    en: 'Login or register with',
    es: 'Iniciar sesión o registrar con',
    pt: 'Fazer login ou registrar com',
  },
  'Or continue with email': {
    en: 'Or continue with email',
    es: 'O continúa con correo electrónico',
    pt: 'O continuar com e-mail',
  },
  'Don\'t have an account?': {
    en: 'Don\'t have an account?',
    es: '¿No tienes una cuenta?',
    pt: 'Não tem uma conta?',
  },
  'Required fields': {
    en: 'Required fields',
    es: 'Campos obligatorios',
    pt: 'Campos obrigatórios',
  },
  'I forgot my password': {
    en: 'I forgot my password',
    es: 'Olvidé mi contraseña',
    pt: 'Esqueci minha senha',
  },
  'I have read and accepted the': {
    en: 'I have read and accepted the',
    es: 'He leído y acepto los',
    pt: 'Li e aceitei os',
  },
  'Reset password': {
    en: 'Reset password',
    es: 'Restablecer contraseña',
    pt: 'Repor senha',
  },
  'Send recovery email': {
    en: 'Send recovery email',
    es: 'Enviar correo de recuperación',
    pt: 'Enviar e-mail de recuperação',
  },
  'You are being redirected': {
    en: 'You are being redirected',
    es: 'Estás siendo redirigido',
    pt: 'Você está sendo redirecionado',
  },
  'Try reentering your login data, or click on “Recover password” if you have forgotten it.': {
    en: 'Try reentering your login data, or click on “Recover password” if you have forgotten it.',
    es: 'Intente reingresar sus datos de inicio de sesión, o haga clic en “Recuperar contraseña” si olvidó su contraseña.',
    pt: 'Tente reentrar seus dados de login, ou clique em “Recuperar senha” se você esqueceu sua senha.',
  },
  'You can login with this email or register with a different email.': {
    en: 'You can login with this email or register with a different email.',
    es: 'Puede iniciar sesión con este correo electrónico o registrar con un correo electrónico diferente.',
    pt: 'Você pode fazer login com este e-mail ou registrar com um e-mail diferente.',
  },
  'The email address you entered is not associated with an account.': {
    en: 'The email address you entered is not associated with an account.',
    es: 'La dirección de correo electrónico que ingresó no está asociada con una cuenta.',
    pt: 'O endereço de e-mail que você digitou não está associado a uma conta.',
  },
  // Federated sign-in (PRO-736). The entry above is the *email* login's version
  // of the same backend code (42215): it speaks of an address the visitor
  // typed, and offers to register. Neither fits here — the visitor picked a
  // Google/Apple account, and the scenes that produce this error are the ones
  // where registering was refused — so the federated path carries its own copy.
  'There is no account linked to this sign-in': {
    en: 'There is no account linked to this sign-in',
    es: 'No hay una cuenta vinculada a este inicio de sesión',
    pt: 'Não há uma conta vinculada a este login',
  },
  'Sign in with the email and password of your account to continue.': {
    en: 'Sign in with the email and password of your account to continue.',
    es: 'Inicie sesión con el correo electrónico y la contraseña de su cuenta para continuar.',
    pt: 'Faça login com o e-mail e a senha da sua conta para continuar.',
  },
  'We could not complete your sign-in': {
    en: 'We could not complete your sign-in',
    es: 'No pudimos completar el inicio de sesión',
    pt: 'Não foi possível concluir o login',
  },
  'Please try again, or sign in with your email and password.': {
    en: 'Please try again, or sign in with your email and password.',
    es: 'Por favor, inténtelo de nuevo o inicie sesión con su correo electrónico y contraseña.',
    pt: 'Por favor, tente novamente ou faça login com seu e-mail e senha.',
  },
  'Continue with email': {
    en: 'Continue with email',
    es: 'Continuar con correo electrónico',
    pt: 'Continuar com e-mail',
  },
  'Your pair code is invalid or expired, please check and try again.': {
    en: 'Your pair code is invalid or expired, please check and try again.',
    es: 'Su código de pareja es inválido o expirado, por favor verifique y intente de nuevo.',
    pt: 'Seu código de parceiro é inválido ou expirado, por favor verifique e tente novamente.',
  },
  'This code has expired or doesn\'t exist. Generate a new code on your TV and enter it here.': {
    en: 'This code has expired or doesn\'t exist. Generate a new code on your TV and enter it here.',
    es: 'Este código venció o no existe. Genere un código nuevo en su TV e ingréselo aquí.',
    pt: 'Este código expirou ou não existe. Gere um novo código na sua TV e digite-o aqui.',
  },
  'Your TV closed the pairing screen. Open it again on your TV, keep it open, and enter the new code.': {
    en: 'Your TV closed the pairing screen. Open it again on your TV, keep it open, and enter the new code.',
    es: 'Su TV cerró la pantalla de vinculación. Ábrala de nuevo en su TV, manténgala abierta e ingrese el código nuevo.',
    pt: 'Sua TV fechou a tela de vinculação. Abra-a novamente na sua TV, mantenha-a aberta e digite o novo código.',
  },
  'We couldn\'t validate the code. Keep the pairing screen open on your TV and try again.': {
    en: 'We couldn\'t validate the code. Keep the pairing screen open on your TV and try again.',
    es: 'No pudimos validar el código. Mantenga abierta la pantalla de vinculación en su TV e inténtelo de nuevo.',
    pt: 'Não conseguimos validar o código. Mantenha a tela de vinculação aberta na sua TV e tente novamente.',
  },
  'There was a problem validating your credentials.': {
    en: 'There was a problem validating your credentials',
    es: 'Hubo un problema validando sus credenciales',
    pt: 'Houve um problema validando suas credenciais',
  },
  'Please try again later.': {
    en: 'Please try again later.',
    es: 'Por favor, inténtelo de nuevo más tarde.',
    pt: 'Por favor, tente novamente mais tarde.',
  },
  // Points at the browser rather than at support, which is the action that
  // actually resolves a 40301: the rejections reaching real users come from an
  // old TV browser or an in-app webview mangling the token, or from reCAPTCHA
  // scoring a webview at the floor — all of which a different browser fixes,
  // and none of which support can.
  'Please try again. If the problem persists, try using a different browser.': {
    en: 'Please try again. If the problem persists, try using a different browser.',
    es: 'Por favor, inténtelo de nuevo. Si el problema persiste, pruebe con otro navegador.',
    pt: 'Por favor, tente novamente. Se o problema persistir, tente usar outro navegador.',
  },
  // Previously unreachable (nothing set extra.recaptchaUnavailable), so it was
  // never translated. FZSPF-3835 makes it reachable.
  'Please refresh the page and try again. If the problem persists, check that your browser is not blocking Google reCAPTCHA.': {
    en: 'Please refresh the page and try again. If the problem persists, check that your browser is not blocking Google reCAPTCHA.',
    es: 'Por favor, refresque la página e inténtelo de nuevo. Si el problema persiste, verifique que su navegador no esté bloqueando Google reCAPTCHA.',
    pt: 'Por favor, atualize a página e tente novamente. Se o problema persistir, verifique se o seu navegador não está bloqueando o Google reCAPTCHA.',
  },
  'Refresh': {
    en: 'Refresh',
    es: 'Refrescar',
    pt: 'Atualizar',
  },
  'Validating your credentials': {
    en: 'Validating your credentials',
    es: 'Validando sus credenciales',
    pt: 'Validando suas credenciais',
  },
  'Use another method': {
    en: 'Use another method',
    es: 'Usar otro método',
    pt: 'Usar outro método',
  },
  'Success': {
    en: 'Success',
    es: 'Éxito',
    pt: 'Sucesso',
  },
  'We have sent you an email with instructions to reset your password.': {
    en: 'We have sent you an email with instructions to reset your password.',
    es: 'Le hemos enviado un correo electrónico con instrucciones para restablecer su contraseña.',
    pt: 'Enviamos um e-mail com instruções para redefinir sua senha.',
  },
  'Please login with your new password.': {
    en: 'Please login with your new password.',
    es: 'Por favor, inicie sesión con su nueva contraseña.',
    pt: 'Por favor, faça login com sua nova senha.',
  },
  'Your device has been successfully paired.': {
    en: 'Your device has been successfully paired.',
    es: 'Su dispositivo ha sido emparejado con éxito.',
    pt: 'Seu dispositivo foi emparelhado com sucesso.',
  },
  'Your device has been successfully paired. Please log in again to keep using the web.': {
    en: 'Your device has been successfully paired. Please log in again to keep using the web.',
    es: 'Su dispositivo ha sido emparejado con éxito. Por favor, inicie sesión nuevamente para seguir usando la web.',
    pt: 'Seu dispositivo foi emparelhado com sucesso. Por favor, faça login novamente para continuar usando a web.',
  },
  'Reenter login data': {
    en: 'Reenter login data',
    es: 'Reingresar datos',
    pt: 'Reentrar dados de login',
  },
  'Invalid authentication link': {
    en: 'Invalid authentication link',
    es: 'Enlace de autenticación inválido',
    pt: 'Link de autenticação inválido',
  },
  'No authentication token was found in the URL. Please try logging in again.': {
    en: 'No authentication token was found in the URL. Please try logging in again.',
    es: 'No se encontró un token de autenticación en la URL. Por favor, intente iniciar sesión nuevamente.',
    pt: 'Não foi encontrado um token de autenticação na URL. Por favor, tente fazer login novamente.',
  },
  'Your request has been submitted': {
    en: 'Your request has been submitted',
    es: 'Su solicitud ha sido enviada',
    pt: 'Sua solicitação foi enviada',
  },
  'All set!': {
    en: 'All set!',
    es: '¡Todo listo!',
    pt: 'Tudo pronto!',
  },
  'Confirm new password': {
    en: 'Confirm new password',
    es: 'Confirmar nueva contraseña',
    pt: 'Confirmar nova senha',
  },
  'Passwords do not match': {
    en: 'Passwords do not match',
    es: 'Las contraseñas no coinciden',
    pt: 'As senhas não coincidem',
  },
  'Enter the code to activate your device': {
    en: 'Enter the code to activate your device',
    es: 'Ingresa el código para activar tu dispositivo',
    pt: 'Insira o código para ativar seu dispositivo',
  },
  'Enter your email to reset your password': {
    en: 'Enter your email to reset your password',
    es: 'Ingresa tu correo electrónico para restablecer tu contraseña',
    pt: 'Insira seu e-mail para redefinir sua senha',
  },
  'Log in to {appTitle}': {
    en: 'Log in to {appTitle}',
    es: 'Ingresa a {appTitle}',
    pt: 'Entre no {appTitle}',
  },
  'Log in or register to access this section\'s content': {
    en: 'Log in or register to access this section\'s content',
    es: 'Inicia sesión o regístrate para acceder al contenido de esta sección',
    pt: 'Faça login ou cadastre-se para acessar o conteúdo desta seção',
  },
  'Enter {appTitle}': {
    en: 'Enter {appTitle}',
    es: 'Ingresar a {appTitle}',
    pt: 'Entrar no {appTitle}',
  },
  'You are already logged in': {
    en: 'You are already logged in',
    es: 'Ya iniciaste sesión',
    pt: 'Você já está conectado',
  },
  'Log out to access this page': {
    en: 'Log out to access this page',
    es: 'Cerrá sesión para acceder a esta página',
    pt: 'Faça logout para acessar esta página',
  },
}

export default translations